import colors from './colors'
import fonts from './fonts'

const button = {
    display: 'inline-block',
}

const rounded = {
    borderRadius: '50%',
}

const actionButton = {
    display: 'block',
    borderRadius: 4,
    boxShadow: '0 0.2em 0.7em 0 rgba(0, 0, 0, 0.5)',
}

const actionButton_label = {
    color: colors.action_buttons.label_color,
    textAlign: 'center',
    display: 'block',
}

const tourMenuButton = {
    width: 300,
    position: 'relative',
    color: colors.white,
    label: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'inline-block',
    },
    icon: {
        width: '1em',
        display: 'inline-block',
        marginRight: '2.8em',
        backgroundPosition: '0 50%',
    },
}

export default {
    button: button,
    rounded: rounded,
    action1: Object.assign({}, actionButton, {
        actionColor: 'yellow',
        label: actionButton_label,
        background: colors.action_buttons.one,
        ':hover': {
            background: colors.action_buttons.one_hover,
        },
        ':active': {
            background: colors.action_buttons.one_active,
        },
    }),
    action2: Object.assign({}, actionButton, {
        actionColor: 'green',
        label: actionButton_label,
        background: colors.action_buttons.two,
        ':hover': {
            background: colors.action_buttons.two_hover,
        },
        ':active': {
            background: colors.action_buttons.two_active,
        },
    }),
    action3: Object.assign({}, actionButton, {
        actionColor: 'blue',
        label: actionButton_label,
        background: colors.action_buttons.three,
        ':hover': {
            background: colors.action_buttons.three_hover,
        },
        ':active': {
            background: colors.action_buttons.three_active,
        },
    }),
    register: Object.assign({}, actionButton, {
        actionColor: 'red',
        label: actionButton_label,
        background: colors.action_buttons.registration,
        ':hover': {
            background: colors.action_buttons.registration_hover,
        },
        ':active': {
            background: colors.action_buttons.registration_active,
        },
    }),
    tourMenuButton: {
        socialShare: Object.assign({}, tourMenuButton, {
            marginBottom: '0.2em',
            svg: {
                width: '1.15em',
                marginRight: '2.8em',
                display: 'inline-block',
            },
            icon: Object.assign({}, tourMenuButton.icon, {
                width: '100%',
                height: '1.365em',
                marginTop: '0.55em',
                marginBottom: '0.55em',
                marginLeft: '0.6em',
                marginRight: '0.6em',
            }),
        }),
        vr: tourMenuButton,
        accessibility: Object.assign({}, tourMenuButton, {
            background: 'white',
            label: {
                left: 'initial',
            },
            icon: {
                width: '1.5em',
            },
        }),
    },
    button_rounded_transparent: Object.assign({}, button, rounded, {
        width: '46px',
        height: '46px',
        background: colors.transparentBlack,
    }),
    desktop_rounded_button: Object.assign({}, button, rounded, {
        marginLeft: '0.5em',
        background: colors.dark_blue_transparent_8,
        width: '2.5em',
        height: '2.5em',
        display: 'inline-block',
        cursor: 'pointer',
        boxShadow: '0 1px 4px 0 rgba(0,0,0,0.3)',
        transition: '0.2s ease-out',
        ':hover': {
            background: colors.dark_blue,
            transform: 'scale(1.1)',
        },
        ':active': {
            background: colors.white,
        },
    }),
}
